import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from "../../components/Layout";
import { useAuthenticationContext } from "../../providers/AuthenticationContext";
export function DashboardLayout({ header, children, theme, slots, sidebar, linkComponent: LinkComponent, }) {
    const { state, enabledServices, actions } = useAuthenticationContext();
    const { user } = state;
    const renderFooterMenu = () => {
        return [...(sidebar?.footerMenu || [])];
    };
    return (_jsx(Layout, { theme: theme, header: {
            user,
            slots: {
                middle: header?.slots?.middle ?? "",
            },
            logoUrl: "/",
        }, slots: slots, sidebar: {
            services: enabledServices,
            customMenuItems: sidebar?.customMenuItems,
            footerMenu: renderFooterMenu(),
            currentServiceId: sidebar.currentServiceId,
        }, linkComponent: LinkComponent, actions: actions, children: children }));
}
//# sourceMappingURL=DashboardLayout.js.map